import { getRegionUrl } from '@domain/routes/urls';
import { IntersectingCountyNodeFields } from '../../generated/graphql';
import { firstNonEmpty } from '@lib/strings/firstNonEmpty';
import { getUniqueCountiesByRegion } from './helpers/getUniqueCountiesByRegion';

interface IProps {
  regionId?: string | null;
  regionName?: string | null;
  countyName?: string;
  intersectingCounties: IntersectingCountyNodeFields[];
}

export const getIntersectingCountiesLinksString = ({
  regionId,
  regionName,
  countyName,
  intersectingCounties,
}: IProps) => {
  if (!regionId || !regionName || !countyName) {
    return '';
  }
  const uniqueCountiesByRegion = getUniqueCountiesByRegion(
    countyName,
    regionId,
    intersectingCounties,
  );

  if (uniqueCountiesByRegion.length === 0) {
    return '';
  }

  return uniqueCountiesByRegion
    .flatMap(({ name, region, country }) => {
      if (!region.regionCode || !region.name || !name) {
        return [];
      }
      const regionDisplayName = firstNonEmpty(region.localName, region.name);
      // nosemgrep: javascript.lang.security.html-in-template-string
      return `${name}, <a href="${getRegionUrl(country.id, region.regionCode, country.countryName, region.name)}">${regionDisplayName}</a>`;
    })
    .join(', ');
};
